<template>
  <div class="rightBlock performanceTabC">
  <el-container>
    <el-main>
      <div class="tab" style="display: block;">
        <child-bottonProductc @updateJourney="updateJourney" :triggerJourney="triggerJourney" :rtUp="rtUp"  :rtDown="rtDown" :safe_top="safe_top" :safe_bottom="safe_bottom" ref="childBottonProductc"></child-bottonProductc>

        <div class="channel">
          <div tip>{{$t("performanceTab.tip")}}</div>
          <el-tabs v-model="activeName" @tab-click="switchTab">
            
            <!-- <el-tab-pane :label="$t('performanceTab.allButton')" name="allButton">

              <div info>
                <p>{{$t("performanceTab.allButtonDesc")}}</p>
              </div>
              <el-radio-group style="visibility: hidden;height:10px;padding: 0;" v-model="showData">
                <el-radio :label="1">显示实时行程高度</el-radio>
                <el-radio :label="2">显示实时按键触发变化</el-radio>
              </el-radio-group>

                <p alljp style="margin-bottom: 20px;">
                  {{$t("performanceTab.setInfo")}}
                  <el-button v-on:click="setPerformanceAll(2)" round size="mini">{{$t("performanceTab.normal")}}</el-button> 
                  <el-button v-on:click="setPerformanceAll(1)" round size="mini" type="success">{{$t("performanceTab.fast")}}</el-button> 
                  <el-button v-on:click="setPerformanceAll(0.5)" round size="mini" type="warning">{{$t("performanceTab.game")}}</el-button> 
                  <el-button v-on:click="setPerformanceAll(RTStep)" round size="mini" type="danger">{{$t("performanceTab.limit")}}</el-button> 
                </p>

                <div class="block" style="padding: 0 25px;">
                  <el-slider v-model="performanceAllButton" @change="setPerformanceAll" :max="maxHigth" :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>
                
            </el-tab-pane> -->

            <el-tab-pane :label="$t('performanceTab.customButton')" name="customButton">
              <div info>
                <p>{{$t("performanceTab.customButtonDesc")}}</p>
              </div>

                <el-row>
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  <el-button style="width: 80px;" v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <el-button style="width: 80px;" v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                  <el-button style="width: 80px;" v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button>
                </el-row>

                <p alljp>
                  <el-button v-on:click="restJourney()" round size="mini" type="info" plain>{{$t("performanceTab.rest")}}</el-button> 

                  <el-button v-on:click="setPerformanceCustom(1)" round size="mini" type="success">{{$t("performanceTab.fast")}}</el-button>
                  <el-button v-on:click="setPerformanceCustom(0.5)" round size="mini" type="warning">{{$t("performanceTab.game")}}</el-button>  
                  <el-button v-on:click="setPerformanceCustom(RTStep)" round size="mini" type="danger">{{$t("performanceTab.limit")}}</el-button> 
                </p>
                <div class="block" style="padding: 0 25px;margin-top: 30px;">
                  <el-slider :marks="marksCustom"  v-model="performanceCustomButton" @change="setPerformanceCustom" :max="maxHigth"  :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>

            </el-tab-pane>

            <el-tab-pane :label="$t('performanceTab.dynamicButton')" name="dynamicButton">
              <div info>
                <p>{{$t("performanceTab.dynamicButtonDesc")}}{{RTStep}}mm</p>
                <el-row>
                  <el-button v-on:click="restJourney()" round size="mini" type="info" plain>{{$t("performanceTab.rest")}}</el-button>
                  <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                  <!-- <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button> -->
                  <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button>
                  <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>

                  <el-switch class="rt" v-model="RTAllJourney" @change="setRTAllJourney" active-text="" :inactive-text="$t('performanceTab.rtAllJourney')"></el-switch>
                </el-row>
              </div>

                <p down>{{$t("performanceTab.rtClick")}}</p>
                <div class="block" style="padding: 0 25px;">
                  <el-slider :marks="marksCustom" v-model="performanceCustomButton"  @change="setPerformanceCustom" :max="maxHigth" :step="RTStep" :format-tooltip="mmVal" show-input width="100px"> </el-slider>
                </div>


                <p down>{{$t("performanceTab.rtDown")}}</p>
                <div class="block" style="padding: 0 25px;">
                  <el-slider :marks="marksRTDown" v-model="RTDown"  @change="setRTDown" :max="maxHigth" :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>

                <p up style="margin-top: 22px;">{{$t("performanceTab.rtUp")}}</p>
                <div class="block" style="padding: 0 25px;">
                  <el-slider :marks="marksRTUp" v-model="RTUp"  @change="setRTUp" :max="maxHigth"  :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>

            </el-tab-pane>

            <el-tab-pane  :label="$t('performanceTab.SafeZone')" name="safeZone">

                <div info style="margin-bottom: 10px;"> 
                  <p style="line-height: 21px;">{{$t("performanceTab.safeZoneDesc")}}</p>
                  <el-link :underline="false" type="danger">{{$t("performanceTab.safeZoneDescAfter")}}</el-link>
                  <el-row style="padding: 16px 0 0px 25px;">
                    <el-button v-on:click="restJourney()" round size="mini" type="info" plain>{{$t("performanceTab.rest")}}</el-button>
                    <el-button v-on:click="buttonSelect('wasd')" round size="mini">{{$t("performanceTab.wasd")}}</el-button>
                    <el-button v-on:click="buttonSelect('ud')" round size="mini">{{$t("performanceTab.ud")}}</el-button>
                    <el-button v-on:click="buttonSelect('wasdud')" round size="mini">{{$t("performanceTab.wasdud")}}</el-button>
                    <el-button v-on:click="buttonSelect('cancel')" round size="mini" type="info" plain>{{$t("performanceTab.customButtonInfo")}}</el-button>
                  </el-row>

                </div>
                <p down>{{$t("performanceTab.top")}}</p>
                <div class="block" style="padding: 0 25px;">
                  <el-slider :marks="marksZoneTop"  v-model="SafeZoneTop"  @change="setSafeZoneTop" max="0.3" :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>

                <p up style="margin-top: 22px;">{{$t("performanceTab.bottom")}}</p>
                <div class="block" style="padding: 0 25px;">
                  <el-slider :marks="marksZoneBottom" v-model="SafeZoneBottom"  @change="setSafeZoneBottom" max="0.3"  :step="RTStep" :format-tooltip="mmVal" show-input width="200px"> </el-slider>
                </div>

            </el-tab-pane>

          </el-tabs>	
          
         <div chart>

            <div kedubgc :style="{height: zHeightDefine + 'px',backgroundColor: zMaxAnimationHeightBgColorDefine,}"></div>
            <div kedu></div>
            <div status>
                <div fluctuate>
                  <p>{{$t("performanceTab.fluctuate")}}</p>
                  <span>{{RealTimeJourneyVal}} mm / {{RealTimeJourneyUS}} us</span>
                </div>
                <el-switch class="test" v-model="openRealtime" @change="listenJourney" active-text="" :inactive-text="$t('performanceTab.test')"></el-switch>

                <div :style="{'background':'url(' + axisCurZ_B + ') no-repeat','background-size':'cover'}" animation><img :style="{top: zTopDefine + 'px' }"  :src="axisCurZ_Y" width="85" /></div>
            </div>
            <div chartnow>
              <div id="myChart" :style="{ width: '300px', height: '200px' }"></div>
            </div>
         </div> 
          
        </div>
      </div>
    </el-main>
  </el-container>
</div>
</template>
<style>
  
#myChart
{
  width: 300px;
  height: 202px;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 139px;

}
</style>
<script>

console.log(process.env.VUE_APP_THEMENAME);
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
import { ToolsHandle } from '../../../../utils/tools.js';

import buttonPaneC from './buttonTabPane/buttonPaneC.vue'
import bottonProductC from './buttonTabPane/bottonProduct.vue'
export default {
  name: 'performanceTabC',
  components: 
  {
    'child-bottonProductc':bottonProductC,
    buttonPaneC
  },
  data() {

    return {
      ThemeConf:null,
      HIDDeviceObj:null,
      activeName: 'customButton',
      option: {},
      showData:1,
      performanceAllButton:2,
      performanceCustomButton:2,
      marksCustom:
      {
        2:
        {
          style:{'font-weight':'bold','font-size':'smaller',"color":"#b1b1b1"},
          label:this.$i18n.t("performanceTab.recommend")
        } 
      },

      RTAllJourney:0,
      RTDown:0.3,
      RTUp:0.3,
      marksRTDown:
      {
        0.3:
        {
          style:{'font-weight':'bold','font-size':'smaller',"color":"#b1b1b1"},
          label:this.$i18n.t("performanceTab.recommend")
        } 
      },
      marksRTUp:
      {
        0.01:
        {
          style:{'font-weight':'bold','font-size':'smaller',"color":"#b1b1b1"},
          label:this.$i18n.t("performanceTab.recommend")
        } 
      },


      SafeZoneTop:0.2,
      SafeZoneBottom:0.1,
      marksZoneTop:
      {
        0.01:
        {
          style:{'font-weight':'bold','font-size':'smaller',"color":"#b1b1b1"},
          label:this.$i18n.t("performanceTab.recommend")
        } 
      },
      marksZoneBottom:
      {
        0:
        {
          style:{'font-weight':'bold','font-size':'smaller',"color":"#b1b1b1"},
          label:this.$i18n.t("performanceTab.recommend")
        } 
      },
      
      openRealtime:false,

      RealTimeJourneyValList:[],
      RealTimeJourneyVal:0,
      RealTimeJourneyUS:0,
      RealTimeJourneyUSAverage:125,
      RealTimeJourneyUSAverageHigh:125,
      RealTimeJourneyUSAverageNormal:240,
      zTopDefine:-31,
      zMaxAnimationDefine:25,

      zHeightDefine:0,
      zMaxAnimationHeightDefine:240,
      zMaxAnimationHeightBgColorDefine:'#e1e1e1',
      zMaxJourneyDefine:4000,
      lineColor:"#929292",
      RTStep:0.02,
      maxHigth:4.0,
      axisCurZ_Y:"",
      axisCurZ_B:"",
      myChart:null
    }
  },
  mounted() 
  { 
    // 基于准备好的dom，初始化echarts实例
    this.myChart = this.$echarts.init(document.getElementById("myChart"),"macarons2");
    this.drawLine();
  },
  methods: 
  {
    //同步更新按键的行程数据
    updateJourney(triggerJourney,rtDown,rtUp,safe_top,safe_bottom)
    {
        this.performanceCustomButton = parseFloat(triggerJourney);

        if(parseFloat(rtUp) != 0)
        {
          this.RTUp = parseFloat(rtUp);
        }
        
        if(parseFloat(rtDown) != 0)
        {
          this.RTDown = parseFloat(rtDown);
        }

        console.log(safe_bottom);

        this.SafeZoneTop = parseFloat(safe_top);
        this.SafeZoneBottom = parseFloat(safe_bottom);

    },
    //自定义轴体
    axisCur(brand,model,rt,maxHigth)
    {
      if(brand == "" || model == "")
      {
          this.axisCurZ_Y =  require("../asserts/image/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/z_b.png");
      }
      else
      {
        try 
        {
          // 尝试导入资源
          this.axisCurZ_Y =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/axis/"+ brand +"/" + model +"/z_b.png");
          // localStorage.setItem('axis',JSON.stringify({"brand":brand,"model":model,"rt":rt,"maxHigth":maxHigth}));

        } catch (e) 
        {
          // 资源不存在，捕获错误
          console.error(`资源不存在`);

          this.axisCurZ_Y =  require("../asserts/image/z_y.png");
          this.axisCurZ_B =  require("../asserts/image/z_b.png");
        }
      }
     
    },
    //初始化配置数据
    async initData()
    {
        this.lineColor = this.ThemeConf.lineColor;
        for(let i in this.ThemeConf.DeviceList)
        {
            if(this.ThemeConf.DeviceList[i].FirmwareVer == this.HIDDeviceObj.FirmwareVer)
            {
              this.RTStep = this.ThemeConf.axisSet.RT;//this.ThemeConf.DeviceList[i].RT;
              this.maxHigth = this.ThemeConf.axisSet.maxHigth;

              if(this.ThemeConf.axisSet.brand != '')
              {
                this.axisCur(this.ThemeConf.axisSet.brand,
                this.ThemeConf.axisSet.model,
                this.ThemeConf.axisSet.RT,
                this.ThemeConf.axisSet.maxHigth);
              }
              else
              {
                this.axisCur(this.ThemeConf.DeviceList[i].axis.brand,
                this.ThemeConf.DeviceList[i].axis.model,
                this.ThemeConf.DeviceList[i].axis.RT,
                this.ThemeConf.DeviceList[i].axis.maxHigth);
              }
              break;
            }
        }

        //读取全局行程
        // setTimeout(()=>{this.readJourneyCustom();},100);
        //读取全局行程
        // setTimeout(()=>{this.readJourneyCustomButton();},700);
        // //读取动态RT行程
        // setTimeout(()=>{this.readDynamicButton();},1200);
        // //读取安全区
        // setTimeout(()=>{this.readSafeZoneButton();},2500);

        //读取全局行程
        await ToolsHandle.delay(1000);
        this.readJourneyCustomButton();
        await ToolsHandle.delay(1000);
        //读取动态RT行程
        this.readDynamicButton();
        await ToolsHandle.delay(5000);
        //读取安全区
        this.readSafeZoneButton();
        
    },
    //初始化刷新数据
    init()
    {
        const ChildBottonProductC = this.$refs.childBottonProductc;
              ChildBottonProductC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
              ChildBottonProductC.HIDDeviceObj = this.HIDDeviceObj;
              ChildBottonProductC.setProductImagePath();

        //实时行程心电图
        if(this.RealTimeJourneyValList.length == 30)
        {
          this.RealTimeJourneyValList.shift();
        }
        this.RealTimeJourneyValList.push(
        [
          new Date(2024, 9, 1, 0, this.RealTimeJourneyVal * 10000),
          this.RealTimeJourneyVal
        ]);

        //实时行程高度
        this.RealTimeJourneyUS = Math.floor(Math.random() * this.RealTimeJourneyUSAverage) + 1;
        this.zMaxAnimationHeightBgColorDefine = this.HIDDeviceObj.curMaxJourneyKeyStatus>1?'#75c54d':'#e1e1e1';

        // this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney + (0.2/38)*(this.HIDDeviceObj.curMaxJourney*10);
        // this.RealTimeJourneyVal = this.RealTimeJourneyVal>4?4:this.RealTimeJourneyVal;

        this.RealTimeJourneyVal = this.HIDDeviceObj.curMaxJourney.toFixed(3);

        this.setZTop();

        //实时行程按键状态
        this.refreshData(this.HIDDeviceObj.MatrixList.KeyMap);


        this.drawLine();

    },
    //读取自定义行程数据
    async readJourneyCustom()
    {
        this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});

        //读取全键盘行程
        const outputReportData = new Uint8Array(cmd10.READ_GLOBAL_JOURNEY_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
        await ToolsHandle.delay(1000);


        this.$notify.closeAll();
        //更新UI
        this.performanceAllButton = this.HIDDeviceObj.journey_global;
        // this.SafeZoneTop = this.HIDDeviceObj.safe_zone_top;
        // this.SafeZoneBottom = this.HIDDeviceObj.safe_zone_bottom;

        const ChildBottonProductC = this.$refs.childBottonProductc;
              ChildBottonProductC.journey_global = this.HIDDeviceObj.journey_global;

    },
    //读取自定义按键数据
    async readJourneyCustomButton()
    {
        this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});

        //读取自定义按键行程
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4;
        let commandButtonJourneyGroups = this.HIDDeviceObj.getButtonLayout4CustomCommand(cmd10);

        for(let i in commandButtonJourneyGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonJourneyGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(15);
        }

        await ToolsHandle.delay(300);
        this.HIDDeviceObj.formatLayout4(this.HIDDeviceObj);

        this.$notify.closeAll();
    },
    //读取安全区
    async readSafeZoneButton()
    {
        //读取按键顶部死区
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE16;
        let commandButtonSAFEAGroups = this.HIDDeviceObj.getButtonLayout16CustomCommand(cmd10);
        for(let i in commandButtonSAFEAGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonSAFEAGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(10);
        }

        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout16(this.HIDDeviceObj);

        await ToolsHandle.delay(500);
        //读取按键底部死区
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE17;
        let commandButtonSAFEDGroups = this.HIDDeviceObj.getButtonLayout17CustomCommand(cmd10);
        for(let i in commandButtonSAFEDGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonSAFEDGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(10);
        }

        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout17(this.HIDDeviceObj);
    },
    //读取动态RT行程
    async readDynamicButton()
    {
        //读取RT全行程开关
        const outputReportData = new Uint8Array(cmd10.READ_DEVICE_RT_ALL_JOURNEY_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
        await ToolsHandle.delay(1000);

        this.RTAllJourney = this.HIDDeviceObj.rt_all_journey == 0?false:true;

       console.log(this.HIDDeviceObj.rt_all_journey);

        //读取按键工作模式，高级功能
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.MODE;
        let commandButtonModeGroups = this.HIDDeviceObj.getButtonLayout8CustomCommand(cmd10);

        for(let i in commandButtonModeGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonModeGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(10);
        }
        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout8(this.HIDDeviceObj);

        //读取RT按键按下行程
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTDOWN14;
        let commandButtonRTDGroups = this.HIDDeviceObj.getButtonLayout14CustomCommand(cmd10);
        for(let i in commandButtonRTDGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonRTDGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(10);
        }

        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout14(this.HIDDeviceObj);


        //读取RT按键弹起行程
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTUP15;
        let commandButtonRTUGroups = this.HIDDeviceObj.getButtonLayout15CustomCommand(cmd10);
        for(let i in commandButtonRTUGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonRTUGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(10);
        }

        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout15(this.HIDDeviceObj);
    },
    //切换行程
    async switchTab(tab, event) 
    {
      // let buttons = document.querySelectorAll('.perfBP li');
      //     buttons.forEach(function(el) 
      //     {
      //         el.classList.remove('uas');
      //         el.classList.remove('has');
      //         el.classList.remove('select');
      //     });
      

      this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});
      if(this.activeName == "allButton")
      {
        //全键盘设置关闭样式选择
        let buttons = document.querySelectorAll('.perfBP li.select');
        buttons.forEach(function(el) 
        {
          el.classList.remove("on");
          el.classList.remove("select");
          el.classList.remove("has");
          el.classList.remove("uas");
        });

        //读取全键盘行程
        const outputReportData = new Uint8Array(cmd10.READ_GLOBAL_JOURNEY_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
        await ToolsHandle.delay(500);

        //更新UI  
        this.performanceAllButton = this.HIDDeviceObj.journey_global;
        // this.SafeZoneTop = this.HIDDeviceObj.safe_zone_top;
        // this.SafeZoneBottom = this.HIDDeviceObj.safe_zone_bottom;

        const ChildBottonProductC = this.$refs.childBottonProductc;
              ChildBottonProductC.journey_global = this.HIDDeviceObj.journey_global;

      }
      else if(this.activeName == "customButton")
      {
        //读取自定义按键行程
        this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4;
        let commandButtonJourneyGroups = this.HIDDeviceObj.getButtonLayout4CustomCommand(cmd10);
        for(let i in commandButtonJourneyGroups)
        {
            this.HIDDeviceObj.typeMatrixPageID = i+1;
            //写入硬件
            const outputReportData = new Uint8Array(commandButtonJourneyGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(50);
        }

        await ToolsHandle.delay(100);
        this.HIDDeviceObj.formatLayout4(this.HIDDeviceObj);

        // const ChildBottonProductC = this.$refs.childBottonProductc;
        //       ChildBottonProductC.setJourneys(this.HIDDeviceObj);

      }
      else if(this.activeName == "dynamicButton")
      {
          this.readDynamicButton();
      }
      else if(this.activeName == "safeZone")
      {
          this.readSafeZoneButton();
      }

        this.$notify.closeAll();
    },
    //选择按键
    buttonSelect(op)
    {
      switch(op)
      {
        case 'cancel':
        {
          let buttons = document.querySelectorAll('.perfBP li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });

        }break;
        case 'wasd':
        {
          let buttons = document.querySelectorAll('.perfBP li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonW = document.querySelector('.perfBP li[name="W"]');
          let buttonA = document.querySelector('.perfBP li[name="A"]');
          let buttonS = document.querySelector('.perfBP li[name="S"]');
          let buttonD = document.querySelector('.perfBP li[name="D"]');
          
              buttonW.classList.add('select');
              buttonA.classList.add('select');
              buttonS.classList.add('select');
              buttonD.classList.add('select');
          
        }break;
        case 'ud':
        {
          let buttons = document.querySelectorAll('.perfBP li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });


          let buttonU = document.querySelector('.perfBP li[name="Up"]');
          let buttonD = document.querySelector('.perfBP li[name="Down"]');
          let buttonL = document.querySelector('.perfBP li[name="Left"]');
          let buttonR = document.querySelector('.perfBP li[name="Right"]');

          if(buttonU == null)
          {
            this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
            return;
          }


          buttonU.classList.add('select');
          buttonD.classList.add('select');
          buttonL.classList.add('select');
          buttonR.classList.add('select');

        }break;
        case 'wasdud':
        {

          let buttons = document.querySelectorAll('.perfBP li');
          buttons.forEach(function(el) 
          {
              el.classList.add('select');
          });

          // let buttonCW = document.querySelector('.perfBP li[name="W"]');
          // let buttonCA = document.querySelector('.perfBP li[name="A"]');
          // let buttonCS = document.querySelector('.perfBP li[name="S"]');
          // let buttonCD = document.querySelector('.perfBP li[name="D"]');
          
          // buttonCW.classList.add('select');
          // buttonCA.classList.add('select');
          // buttonCS.classList.add('select');
          // buttonCD.classList.add('select');


          // let buttonU = document.querySelector('.perfBP li[name="UP"]');
          // let buttonD = document.querySelector('.perfBP li[name="DOWN"]');
          // let buttonL = document.querySelector('.perfBP li[name="LEFT"]');
          // let buttonR = document.querySelector('.perfBP li[name="RIGHT"]');

          // if(buttonU == null)
          // {
          //   this.$message({message:this.$i18n.t("msg.buttonUWarn"),type: 'warning',center: true,offset:500,duration:1000});
          //   return;
          // }

          // buttonU.classList.add('select');
          // buttonD.classList.add('select');
          // buttonL.classList.add('select');
          // buttonR.classList.add('select');

        }break;

      }

    },
    //发送获取行程实时信息命令
    listenJourney()
    {
      let buttons = document.querySelectorAll('.perfBP li');
          buttons.forEach(function(el) 
          {
              el.classList.remove('select');
          });
          
        this.RealTimeJourneyValList = [];
        this.updateDataLine();
        if(this.openRealtime)
        {
            this.$confirm(this.$i18n.t("msg.confirmInfo"), this.$i18n.t("msg.confirmTit"), 
            {
              confirmButtonText:  this.$i18n.t("msg.confirmHigh"),
              cancelButtonText: this.$i18n.t("msg.confirmNormal"),
              showClose:false,
              closeOnClickModal:false,
              closeOnPressEscape:false,
              closeOnHashChange:false,
              type: 'warning'
            }).then(() => 
            {
                this.RealTimeJourneyUSAverage = this.RealTimeJourneyUSAverageHigh;
                this.HIDDeviceObj.stopListening();
                // this.HIDDeviceObj.startListeningHigh(cmd10);
                this.HIDDeviceObj.startListeningNormal(cmd10);

            }).catch(() => {

              this.RealTimeJourneyUSAverage = this.RealTimeJourneyUSAverageNormal;
              this.HIDDeviceObj.stopListening();
              this.HIDDeviceObj.startListeningNormal(cmd10);
              
            });

        }
        else
        {
          this.HIDDeviceObj.stopListening();
        }
      
    },
    stopJourney()
    {
        this.openRealtime = false;
        this.HIDDeviceObj.stopListening();
    },
    //刷新按键状态
    refreshData(mapData)
    {
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyName = bottonObj.key_name;
              if(keyName == 0)
                  continue;

              let button = document.querySelector('li[name='+ keyName +']');
              if(!button)
                  continue;

              if(bottonObj.key_status == 2)
              {
                 button.classList.add('on');
              }
              else
              {
                  button.classList.remove('on');
              }

          }
        }
    },
    //刷新按键RT自定义数据
    refreshKeyData(type)
    {
        let context = this;
        let buttons = document.querySelectorAll('.perfBP li.select');
        let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
        //组装矩阵数据
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyNameFromMap = bottonObj.key_name;

              buttons.forEach(function(el) 
              {
                  let keyName  = el.getAttribute("name");

                  // el.classList.remove("on");
                  // el.classList.remove("select");
                  el.classList.add("has");

                  if(keyName == keyNameFromMap)
                  {
                      if(type == "SafeZone")
                      {
                        mapData[i][j].safe_zone_top = context.SafeZoneTop;
                        mapData[i][j].safe_zone_bottom = context.SafeZoneBottom;
                      }
                      else
                      {
                        mapData[i][j].select = true;
                        // mapData[i][j].working_mode = '32';
                        mapData[i][j].journey_RT.down = context.RTDown;
                        mapData[i][j].journey_RT.up = context.RTUp;
                        mapData[i][j].journey_trigger = context.performanceCustomButton;
                      }                      
                  }
              });
          }
        }

        //刷新数据
        const ProductButtonC = this.$refs.childBottonProductc;
              ProductButtonC.KeyMap = mapData;
        
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

    },
    //刷新按键自定义数据
    refreshCustomKeyData()
    {
        let context = this;
        let buttons = document.querySelectorAll('.perfBP li.select');
        let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
        //组装矩阵数据
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyNameFromMap = bottonObj.key_name;

              buttons.forEach(function(el) 
              {
                  let keyName  = el.getAttribute("name");

                  // el.classList.remove("on");
                  // el.classList.remove("select");
                  // el.classList.add("has");

                  if(keyName == keyNameFromMap)
                  {
                      mapData[i][j].select = true;
                      mapData[i][j].journey_trigger = context.performanceCustomButton;
                  }
              });
          }
        }

        //刷新数据
        const ProductButtonC = this.$refs.childBottonProductc;
              ProductButtonC.KeyMap = mapData;
        
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

    },
    //刷新按键重置数据
    refreshResatKeyData()
    {
        let context = this;
        let buttons = document.querySelectorAll('.perfBP li.select');
        let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
        //组装矩阵数据
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyNameFromMap = bottonObj.key_name;

              buttons.forEach(function(el) 
              {
                  let keyName  = el.getAttribute("name");
                  if(keyName == keyNameFromMap)
                  {
                      mapData[i][j].select = false;
                      mapData[i][j].working_mode = 0;
                      mapData[i][j].journey_trigger = context.performanceCustomButton;
                  }
              });
          }
        }

        //刷新数据
        const ProductButtonC = this.$refs.childBottonProductc;
              ProductButtonC.KeyMap = mapData;
        
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

    },
    //刷新绘制心跳图
    updateDataLine()
    {
      var context = this;
      // 使用setOption更新图表
      this.myChart.setOption({

        series : [{data:context.RealTimeJourneyValList}]
      });
  },
    //初始化绘制心跳图
    drawLine() 
    {
      var context = this;
      // 绘制图表
      this.myChart.setOption({
 
        tooltip : {
        trigger: 'item',
        formatter : function (params) {

            return params.value[1];
          }
        },
        grid: 
        {
          // width: 280,
          show: true, // 显示网格
          borderWidth: 1, // 边框宽度
          borderColor: '#ccc', // 边框颜色
          // 网格线的样式
          lineStyle: 
          {
              color: '#ccc', // 网格线颜色
              width: 1, // 网格线宽度
              type: 'solid' // 网格线类型
          },
          y2: 60
        },
        xAxis : 
        [
            {
              show:false,
              type : 'category',
              splitNumber:'auto',
              boundaryGap:false,
              interval: 0
            }
        ],
        yAxis : [
            {
                type : 'value',
                inverse:true,
                min: 0.0, // 设置最小刻度值
                max: 4.0, // 设置最大刻度值
                axisTick: {alignWithLabel: true},
                axisLabel: 
                {
                  formatter: function(value) 
                  {
                      return value.toFixed(1); // 保留一位小数
                  }
                }
            },
        ],
        color: [context.lineColor, context.lineColor, context.lineColor],
        series : [
            {
                name: '实时行程',
                type: 'line',
                showAllSymbol: false,
                smooth: true,
                symbolSize: function (value)
                {
                    return 1;
                },
                data: context.RealTimeJourneyValList
            }
        ]
        });
    },
    //刷新绘制行程刻度尺
    setZTop()
    {
        //按压
        let minTop = this.zMaxAnimationDefine/this.zMaxJourneyDefine;
        this.zTopDefine = -31 + this.RealTimeJourneyVal*1000*minTop;
        this.zTopDefine = this.zTopDefine>this.zMaxAnimationDefine?-31:this.zTopDefine;

        //高度
        let minHeight = this.zMaxAnimationHeightDefine/this.zMaxJourneyDefine;
        this.zHeightDefine = this.RealTimeJourneyVal*1000*minHeight;
        this.zHeightDefine = this.zHeightDefine>this.zMaxAnimationHeightDefine?0:this.zHeightDefine;

    },
    //设置全局按键行程触发点
    setPerformanceAll(val)
    {
        val = parseFloat(val);
        //停止测试
        this.stopJourney();

        this.performanceAllButton = (val==0)?parseFloat(this.RTStep):val;
        
        let value = this.performanceAllButton * 1000;
            value = HIDDeviceObj.getHighLowBits(value);

        cmd10.SET_GLOBAL_JOURNEY_CMD[7] = value[0];
        cmd10.SET_GLOBAL_JOURNEY_CMD[8] = value[1];

        //写入硬件
        const outputReportData = new Uint8Array(cmd10.SET_GLOBAL_JOURNEY_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

        this.$message({message:this.$i18n.t("msg.performanceAll"),type: 'success',center: true,offset:500,duration:1000});
    },
    //设置自定义按键行程触发点
    setPerformanceCustom(val)
    {        
        val = parseFloat(val);
        //停止测试
        this.stopJourney();

        let buttons = document.querySelectorAll('.perfBP li.select');
        if(buttons.length == 0)
        {
          this.$message({message:this.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
          return;
        }

        this.performanceCustomButton = val==0?parseFloat(this.RTStep):val;
        let commandGroups =  HIDDeviceObj.getButtonJourneyCommand(buttons,this.performanceCustomButton,cmd10);

        for(let i in commandGroups)
        {
            //写入硬件
            const outputReportData = new Uint8Array(commandGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

        }
        
        //刷新UI
        this.refreshCustomKeyData();
        this.$message({message:this.$i18n.t("msg.performanceCustom"),type: 'success',center: true,offset:500,duration:1000});
    },
    //设置RT按键行程触发点
    async setRTUp(val)
    {
        val = parseFloat(val);
        //停止测试
        this.stopJourney();

        let buttons = document.querySelectorAll('.perfBP li.select');
        if(buttons.length == 0)
        {
          this.$message({message:this.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
          return;
        }

        this.RTUp = val==0?parseFloat(this.RTStep):val;
        this.RTDown = this.RTDown;
        let commandRTUpGroups =  HIDDeviceObj.getButtonRTCommand(buttons,this.RTUp,this.RTDown,cmd10);

        for(let i in commandRTUpGroups)
        {
            //写入硬件
            const outputReportData = new Uint8Array(commandRTUpGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(50);
        }
        
        //刷新UI
        this.refreshKeyData("RT");
        this.initData();
        this.$message({message:this.$i18n.t("msg.RT"),type: 'success',center: true,offset:500,duration:1000});
    },
    //设置RT按键弹起尺度
    async setRTDown(val)
    {
        val = parseFloat(val);
        //停止测试
        this.stopJourney();

        let buttons = document.querySelectorAll('.perfBP li.select');
        if(buttons.length == 0)
        {
          this.$message({message:this.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
          return;
        }

        this.RTDown = val==0?parseFloat(this.RTStep):val;
        this.RTUp = this.RTUp;

        let commandRTDownGroups =  HIDDeviceObj.getButtonRTCommand(buttons,this.RTUp,this.RTDown,cmd10);

        for(let i in commandRTDownGroups)
        {
            //写入硬件
            const outputReportData = new Uint8Array(commandRTDownGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

            await ToolsHandle.delay(50);
        }

        //刷新UI
        this.refreshKeyData("RT");
        this.initData();
        this.$message({message:this.$i18n.t("msg.RT"),type: 'success',center: true,offset:500,duration:1000});
    },
    //重置设置的按键
    restJourney()
    {
      let buttons = document.querySelectorAll('.perfBP li.select');
      if(buttons.length == 0)
      {
        this.$message({message:this.$i18n.t("msg.RestWarn"),type: 'warning',center: true,offset:500,duration:1000});
        return;
      }

      let commandGroups =  HIDDeviceObj.getButtonRestJourneyCommand(buttons,cmd10);
      for(let i in commandGroups)
      {
          //写入硬件
          const outputReportData = new Uint8Array(commandGroups[i].map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
          
      }

      this.performanceCustomButton = 2;
      this.RTDown = 0.3;
      this.RTUp = 0.3;
      this.refreshResatKeyData();
      // buttons.forEach(function(el) 
      // {
      //   el.classList.remove("on");
      //   el.classList.remove("select");
      //   el.classList.remove("has");
      //   el.classList.remove("uas");
      // });
      
      this.$message({message:this.$i18n.t("msg.Rest"),type: 'success',center: true,offset:500,duration:1000});
    },
    //设置顶部安全区
    setSafeZoneTop(val)
    {
        //停止测试
        this.stopJourney();
        let buttons = document.querySelectorAll('.perfBP li.select');
        if(buttons.length == 0)
        {
          this.$message({message:this.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
          return;
        }

        //顶部//底部
        this.SafeZoneTop = val;
        this.SafeZoneBottom = this.SafeZoneBottom;

        console.log(this.SafeZoneBottom);

        let commandSafeZoneGroups =  HIDDeviceObj.getButtonSafeZoneCommand(buttons,this.SafeZoneTop,this.SafeZoneBottom,cmd10);
        for(let i in commandSafeZoneGroups)
        {
            //写入硬件
            const outputReportData = new Uint8Array(commandSafeZoneGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
        }

        //刷新UI
        this.refreshKeyData("SafeZone");
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
    },
    //设置底部安全区
    setSafeZoneBottom(val)
    {
        //停止测试
        this.stopJourney();
        let buttons = document.querySelectorAll('.perfBP li.select');
        if(buttons.length == 0)
        {
          this.$message({message:this.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
          return;
        }

        //顶部//底部
        this.SafeZoneTop = this.SafeZoneTop;
        this.SafeZoneBottom = val;
    
        let commandSafeZoneGroups =  HIDDeviceObj.getButtonSafeZoneCommand(buttons,this.SafeZoneTop,this.SafeZoneBottom,cmd10);
        for(let i in commandSafeZoneGroups)
        {
            //写入硬件
            const outputReportData = new Uint8Array(commandSafeZoneGroups[i].map(hex => parseInt(hex, 16)));
            this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);
        }

        //刷新UI
        this.refreshKeyData("SafeZone");
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});
    },
    //RT全行程开关
    setRTAllJourney()
    {
      this.$confirm(this.$i18n.t("msg.confirmInfoRT"), this.$i18n.t("msg.confirmTit"), 
      {
        // confirmButtonText:  this.$i18n.t("msg.confirmHigh"),
        // cancelButtonText: this.$i18n.t("msg.confirmNormal"),
        showClose:false,
        closeOnClickModal:false,
        closeOnPressEscape:false,
        closeOnHashChange:false,
        type: 'warning'
      }).then(() => 
      {

        //停止测试
        this.stopJourney();

        cmd10.SET_DEVICE_RT_ALL_JOURNEY_CMD[5] = this.RTAllJourney?1:0;
        //写入硬件
        const outputReportData = new Uint8Array(cmd10.SET_DEVICE_RT_ALL_JOURNEY_CMD.map(hex => parseInt(hex, 16)));
        this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

      }).catch(() => {


        this.RTAllJourney = !this.RTAllJourney;

      });
      
    },
    mmVal(val)
    {
         return val+' (mm)';
    }
  } 
}

</script>